<template>
    <div class="w-[26px] h-[26px] overflow-hidden">
        <div class="spinner center">
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.spinner {
    font-size: 26px;
    position: relative;
    display: inline-block;
    width: 26px;
    height: 26px;

    .spinner-blade {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
        width: 2px;
        height: 7px;
        border-radius: 0.0555em;
        background-color: transparent;
        transform-origin: center -6px;
        animation: spinner-fade 1s infinite linear;

        @for $index from 1 through 12 {
            &:nth-child(#{$index}) {
                $delay: (
                    $index - 1) * 0.083s;
                animation-delay: $delay;
                transform: rotate(($index - 1) * 30deg
                );
        }
    }
}
}

@keyframes spinner-fade {
    0% {
        background-color: #69717d;
    }

    100% {
        background-color: transparent;
    }
}
</style>
